// extracted by mini-css-extract-plugin
export default {"input":"mAZF70It--PaymentPlanSelection_input__y0fVa","text":"mAZF70It--PaymentPlanSelection_text__Ez3qP"};